import './Loader.styled.scss'

export const Loader = () => (
  <div className="loaderWrapper">
    <span className="loader" />
  </div>
)
